import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useDispatch } from 'react-redux';
import Image from 'next/image';

import Button from '@/components/ui/Button/Button';
import { actions as cabinetActions } from '@/domains/cabinet';
import { ETheme } from '@/enums/theme';

import styles from './styles.module.scss';

const TariffContent = ({ item, theme, onClick }) => {
  const { t, lang } = useTranslation();
  const dispatch = useDispatch();

  const clickHandler = React.useCallback(() => {
    dispatch(cabinetActions.setTariffModal(true));
    dispatch(cabinetActions.setIsPackageOrTariff(item?.type === 'tariff'));
    dispatch(cabinetActions.setSelectedTariff(item));
  }, [item]);

  const renderAdditions = (item, index) => {
    return (
      <div className={styles.infoText} key={index}>
        <div className={styles.plus}>+</div>
        <span>{item}</span>
      </div>
    );
  };

  return (
    <div className={styles.content}>
      {!!item?.sections &&
        item?.sections?.map((section) => (
          <div key={section.heading_text} className={styles.itemContent}>
            <Image
              src={
                theme?.resolvedTheme === ETheme.DARK_MODE &&
                section?.dark_mode_left_icon
                  ? section?.dark_mode_left_icon
                  : section?.left_icon
              }
              alt={section.heading_text}
              title={section.heading_text}
              height={24}
              width={24}
              loading='lazy'
            />
            <div className={styles.info}>
              <div className={styles.itemIcon}>
                <span className={styles.tariff}>{section?.text}</span>
                {section?.right_icons && (
                  <>
                    {section?.right_icons?.map((icon, index) => (
                      <Image
                        key={index}
                        src={icon}
                        alt={section.heading_text}
                        title={section.heading_text}
                        height={24}
                        width={24}
                        loading='lazy'
                      />
                    ))}
                  </>
                )}
              </div>
              <span className={styles.text}>{section?.heading_text}</span>
            </div>
          </div>
        ))}
      {!!item?.additions &&
        item?.additions?.map((item, index) => {
          return renderAdditions(item, index);
        })}
      <div
        className={`${styles.contentBottom} ${
          item?.button_slug && styles.contentBottom__popUp
        }`}
      >
        {item?.button_slug && (
          <Button
            Component={'a'}
            variant={'outline'}
            size={'normal'}
            onClick={onClick}
            href={
              item?.button_slug
                ? item?.button_slug
                : item?.external_link?.concat(`?___store=${lang}`)
            }
            className={`${item?.button_slug && styles.seeMore}`}
            data-testid={'tariff-see-more'}
          >
            {t('common:See more')}
          </Button>
        )}

        {item?.isSubscribable && (
          <Button
            size={'normal'}
            onClick={clickHandler}
            data-testid='tariff-subscribe-button'
            className={`bkc-gtm_tracking
        ${!item?.button_slug ? 'external_link' : ''} ${item?.name} ${
              styles.button
            }
          ${item?.button_slug && styles.button__tariffButton}
          `}
          >
            {t('common:Subscribe')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default React.memo(TariffContent);
